<div class="component-container" fxLayout="row" fxLayoutAlign="center center">
  <p *ngIf="state === 'connecting'">Connecting your integration... Please Wait.</p>
  <p *ngIf="state === 'connected'">The integration has been connected. You may now close this window.</p>
</div>
